import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const VerticalToggleButtons = () => {
  const [view, setView] = React.useState("list");

  const handleChange = (event, nextView) => {
    setView(nextView);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Vertical Toggle Button
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          The buttons can be stacked vertically with the orientation prop set to
          "vertical".
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "const Index = () => {\n" +
              '  const [view, setView] = React.useState("list");\n' +
              "\n" +
              "  const handleChange = (event, nextView) => {\n" +
              "    setView(nextView);\n" +
              "  };\n" +
              "\n" +
              "  return (\n" +
              "    <ToggleButtonGroup\n" +
              '      orientation="vertical"\n' +
              "      value={view}\n" +
              "      exclusive\n" +
              "      onChange={handleChange}\n" +
              "    >\n" +
              '      <ToggleButton value="list" aria-label="list">\n' +
              "        <ViewListIcon />\n" +
              "      </ToggleButton>\n" +
              '      <ToggleButton value="module" aria-label="module">\n' +
              "        <ViewModuleIcon />\n" +
              "      </ToggleButton>\n" +
              '      <ToggleButton value="quilt" aria-label="quilt">\n' +
              "        <ViewQuiltIcon />\n" +
              "      </ToggleButton>\n" +
              "    </ToggleButtonGroup>\n" +
              "  );\n" +
              "};\n"
            }
          >
            <ToggleButtonGroup
              orientation="vertical"
              value={view}
              exclusive
              onChange={handleChange}
            >
              <ToggleButton value="list" aria-label="list">
                {/*<ViewListIcon />*/}
              </ToggleButton>
              <ToggleButton value="module" aria-label="module">
                {/*<ViewModuleIcon />*/}
              </ToggleButton>
              <ToggleButton value="quilt" aria-label="quilt">
                {/*<ViewQuiltIcon />*/}
              </ToggleButton>
            </ToggleButtonGroup>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default VerticalToggleButtons;
